import { faCircleInfo, faCreditCard, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FC, Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Select, SelectCustom, Tooltip } from '@bepro-travel/fe.ui';

export enum PaymentType {
  Normal = 'Normal',
  Credit = 'Credit',
}

export const listOfTransactionTypes = [{ value: PaymentType.Normal, label: 'normal' }];

interface BookPaymentProps {
  onClickSend: () => void;
  onClickSubmit: (info: any) => void;
  disabled: boolean;
  privileges: any;
  credit2000?: any;
  isFormValid?: boolean;
}

const BookPayment: FC<BookPaymentProps> = (props) => {
  const [t] = useTranslation() as unknown as [(key: string) => string];
  const [normalList, setNormalList] = useState<Select[]>([]);
  const [creditList, setCreditList] = useState<Select[]>([]);
  const [credit2000model, setCredit2000Model] = useState<any | undefined>(props?.credit2000);

  useEffect(() => {
    const newNormalList =
      props.credit2000?.listOfRegularPayments
        .filter((payment: any) => !payment.disabled)
        .map((payment: any) => ({
          value: +payment.value,
          label: payment.text,
        })) || [];

    const newCreditList =
      props.credit2000?.listOfCreditPayments.map((transaction: any) => ({
        value: +transaction.value,
        label: transaction.text,
      })) || [];

    setCreditList(newCreditList);
    setNormalList(newNormalList);
  }, [props.credit2000]);

  const onClickBook = () => {
    props.onClickSubmit(credit2000model!);
  };

  const onClickSend = () => {
    props.onClickSend();
  };

  return (
    <Fragment>
      <div className="title text-md mb-15">{t('passenger.methods_of_payment')}</div>
      <div className="book-payment mb-20">
        <div className="title text-md mb-20 mt-10">
          <FontAwesomeIcon icon={faCreditCard as any} className="mr-5 text-sm text-contrast" />
          <span className="mr-5">{t('passenger.fast_secure')}</span>
        </div>
        {props.privileges?.creditCardAllowed && !!props.credit2000 && (
          <div className="form-wrapper row">
            <div className="col-md-3 col-12">
              <div className="form-group">
                <div className="mb-5">{t('passenger.transaction_type')}</div>
                <SelectCustom
                  options={listOfTransactionTypes}
                  onChange={(typeOfTransaction) =>
                    setCredit2000Model({ ...credit2000model!, typeOfTransaction })
                  }
                  value={credit2000model?.typeOfTransaction}
                  needToTranslate={true}
                />
              </div>
            </div>
            <div className="col-md-6 col-12">
              {credit2000model?.typeOfTransaction === PaymentType.Credit && (
                <div className="form-group">
                  <div className="mb-5">{t('passenger.number_of_payments')}</div>
                  <SelectCustom
                    options={creditList}
                    onChange={(numberOfCreditPayments) =>
                      setCredit2000Model({ ...credit2000model, numberOfCreditPayments })
                    }
                    value={credit2000model.numberOfCreditPayments}
                  />
                </div>
              )}

              {credit2000model?.typeOfTransaction === PaymentType.Normal && (
                <div className="form-group">
                  <div className="mb-5">{t('passenger.number_of_payments')}</div>
                  <SelectCustom
                    options={normalList}
                    onChange={(numberOfRegularPayments) =>
                      setCredit2000Model({ ...credit2000model, numberOfRegularPayments })
                    }
                    value={credit2000model.numberOfRegularPayments}
                  />
                </div>
              )}
            </div>

            <div className="col-md-3 col-12 book-payment-topbtn">
              <Button
                className="btn btn-primary btn-lg btn-green"
                title={t('hotel.book')}
                onClick={() => onClickBook()}
              />
            </div>
          </div>
        )}

        {false && (
          <div className="flex-between form-wrapper row">
            <div className="col-12 col-md-9">
              {props.privileges?.proposalAllowed && (
                <Tooltip
                  content={t('passenger.green_button_tooltip')}
                  multiLine={true}
                  position="top"
                  children={
                    <div className="title text-md">
                      <FontAwesomeIcon icon={faEnvelope as any} className="mr-5 text-sm text-contrast" />
                      <span className="mr-5">{t('passenger.send_request_to_consultant')}</span>
                      <FontAwesomeIcon icon={faCircleInfo as any} className="mr-5 text-sm text-contrast" />
                    </div>
                  }
                />
              )}
              {props.privileges?.bookAllowed && (
                <div className="title text-md">
                  <FontAwesomeIcon icon={faEnvelope as any} className="mr-5 text-sm text-contrast" />
                  <span className="mr-5">{t('passenger.confirm_order_text')}</span>
                </div>
              )}
            </div>

            <div className="col-md-3 col-12">
              <Button
                className="btn btn-primary btn-lg"
                title={t(
                  props.privileges?.proposalAllowed
                    ? 'passenger.send_request'
                    : 'passenger.confirm_order'
                )}
                onClick={() => onClickSend()}
                disabled={props.disabled}
              />
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default BookPayment;
